import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { BreadcrumbNav } from "components/molecules";
import { Source, UserLevel } from "utils/constant";
import Wilayah from "services/Wilayah";
import Fasyankes from "services/Fasyankes";
import Laporan from "services/Laporan";
import TableComponent from "./Table";
import FilterSection from "./Filter";
import { generateLevelOptions } from "utils/helpers";
import LoadingSpinner from "components/LoadingSpinner";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const LaporanService = new Laporan();

const DetailLaporan = () => {
  const module = "Laporan Rekap Kelambu";
  const { currentUser } = useSelector((state) => state.authReducer);
  const history = useHistory();
  const tableRef = useRef(null);

  const [reportData, setReportData] = useState([]);
  const [showFilter, setShowFilter] = useState(true);
  const [showData, setShowData] = useState(false);
  const [levelData, setLevelData] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(currentUser.level);
  const [applySelectedLevel, setApplySelectedLevel] = useState(
    currentUser.level
  );
  const [currentLevel, setCurrentLevel] = useState("");
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
  });
  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );
  const [selectedFasyankes, setSelectedFasyankes] = useState(
    currentUser?.fasyankes_id
  );
  const [isLoading, setIsLoading] = useState(false);
  const [reportInfo, setReportInfo] = useState({});

  const [laporanTipe, setLaporanTipe] = useState("");

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prev) => ({
        ...prev,
        provinces: response.province.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });
      setLevelDataOptions((prev) => ({
        ...prev,
        districts: response.district.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
      });
      setLevelDataOptions((prev) => ({
        ...prev,
        fasyankes: response.fasyankes.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAllProvincies();
    if (selectedProvince)
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    if (selectedDistrict)
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
  }, [selectedProvince, selectedDistrict]);

  useEffect(() => {
    setLevelData(generateLevelOptions(currentUser?.level));
  }, [currentUser]);

  const handleApplyFilter = async (payload) => {
    setApplySelectedLevel(payload.level);
    setIsLoading(true);
    setShowData(false);

    const params = { ...payload };

    setLaporanTipe(payload.kelambu_type);

    try {
      const response = await LaporanService.RekapKelambu(params);

      let statusPeriode = "";
      let periode = "";
      if (payload.period === "year") {
        statusPeriode = "Tahunan";
        periode = String(payload.year);
      } else if (payload.period === "range") {
        statusPeriode = "Bulanan (Range)";
        periode = `${payload.start_period} s/d ${payload.end_period}`;
      }

      setReportInfo({
        statusPeriode,
        periode,
        province: selectedProvince,
        district: selectedDistrict,
        fasyankes: selectedFasyankes,
      });

      setReportData(response);
      setCurrentLevel(params.level);
    } catch (error) {
      console.error(error);
      setReportData([]);
    } finally {
      setIsLoading(false);
      setShowData(true);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <BreadcrumbNav
        items={[
          { label: "Laporan", onClick: () => history.push("/laporan") },
          { label: module },
        ]}
      />

      <FilterSection
        currentUser={currentUser}
        // (hapus semua prop periode lama — tidak dipakai)
        selectedLevel={selectedLevel}
        setSelectedLevel={setSelectedLevel}
        levelData={levelData}
        levelDataOptions={levelDataOptions}
        setLevelIdValue={setLevelIdValue}
        selectedProvince={selectedProvince}
        setSelectedProvince={setSelectedProvince}
        selectedDistrict={selectedDistrict}
        setSelectedDistrict={setSelectedDistrict}
        selectedFasyankes={selectedFasyankes}
        setSelectedFasyankes={setSelectedFasyankes}
        handleApplyFilter={handleApplyFilter}
        tableRef={tableRef}
        showData={showData}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        levelIdValue={levelIdValue}
        reportName="LAPORAN_REKAP_KELAMBU"
      />

      {isLoading && !showData && <LoadingSpinner />}

      {showData && (
        <div className="table-container">
          <div className="data-title">
            <h2>
              {laporanTipe === "Kelambu Massal Total"
                ? "Kelambu Massal"
                : laporanTipe}
            </h2>
          </div>
          <div className="data-main">
            <TableComponent
              currentLevel={applySelectedLevel}
              reportsData={reportData}
              tableRef={tableRef}
              reportInfo={reportInfo}
              laporanType={laporanTipe}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailLaporan;
